module.exports = __webpack_public_path__ + "img/exercise_volume_icon.13b77f6d.png";